export const UPDATE_SALESMAN_LIST = 'update_salesman_list';
export const SET_BUCKET_DOMAIN = 'SET_BUCKET_DOMAIN'
export const SET_BUCKET_DOMAIN_TOKEN = 'SET_BUCKET_DOMAIN_TOKEN'